/**
 * @generated SignedSource<<d728de793e1fed59e6efec7c0f867e88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVEmployeeRoleDialog_EmployeeItem$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "TVEmployeeRoleDialog_EmployeeItem";
};
export type TVEmployeeRoleDialog_EmployeeItem$key = {
  readonly " $data"?: TVEmployeeRoleDialog_EmployeeItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVEmployeeRoleDialog_EmployeeItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVEmployeeRoleDialog_EmployeeItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "cdb68ba67e8732e8f79112969be9f475";

export default node;
